import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import dynamicSwitcherIcon from 'assets/dashboard/dynamicSwitcher.png';
import PayoutDashboard from './payout';

export const DYNAMIC_SWITCHER_RESOURCES = {
	dynamicSwitcherPayout: 'dynamicSwitcherPayout'
};

export const URL = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/dynamicSwitcher/${DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout}`
};

export const LABEL = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: 'Dynamic Switcher Payout'
};

export const COMPONENT = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: PayoutDashboard
};

export const CONFIG_RESOURCE = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: 'Dynamic Switcher Payout'
};

export const GET_ACTION = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: 'getDynamicSwitcherPayoutPage'
};

export const IMAGE_SOURCE = {
	[DYNAMIC_SWITCHER_RESOURCES.dynamicSwitcherPayout]: dynamicSwitcherIcon
};
